import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
    CartesianGrid
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    return (
        <div
            style={{
                background: "#fff",
                padding: "10px 14px",
                borderRadius: 8,
                boxShadow: "0 8px 25px rgba(0,0,0,.25)",
                color: "#000"
            }}
        >
            <strong>{label}</strong>
            <div style={{ marginTop: 6 }}>
                Başvuru: <b>{payload[0]?.value ?? 0}</b>
            </div>
            <div>
                Onaylanan: <b>{payload[1]?.value ?? 0}</b>
            </div>
        </div>
    );
};

const ApplicationTrendChart = ({ data = [] }) => {
    return (
        <div className="card">
            <h3 className="card-title">Son 7 Gün Başvuru Trendi</h3>
            <ResponsiveContainer width="100%" height={260}>
                <LineChart
                    data={data}
                    margin={{ top: 30, right: 20, left: -20, bottom: 0 }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,.1)" />
                    <XAxis
                        dataKey="label"
                        tick={{ fill: "#fff", fontSize: 12 }}
                    />
                    <YAxis allowDecimals={false} tick={{ fill: "#fff" }} />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend wrapperStyle={{ color: "#fff" }} />
                    <Line
                        type="monotone"
                        dataKey="applications"
                        name="Başvuru"
                        stroke="var(--valtekPrimary)"
                        strokeWidth={2}
                        dot={{ fill: "var(--valtekPrimary)" }}
                    />
                    <Line
                        type="monotone"
                        dataKey="approved"
                        name="Onaylanan"
                        stroke="var(--valtekGreen)"
                        strokeWidth={2}
                        dot={{ fill: "var(--valtekGreen)" }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ApplicationTrendChart;
